<template>
  <el-dialog
    :title="model.id > 0 ? '编辑人员' : '添加人员'"
    :visible.sync="visible"
    label-width="100px"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="姓名" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone_number">
        <el-input
          v-model="model.phone_number"
          autocomplete="off"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item label="基地" prop="base_id">
        <BaseSelect v-model="model.base_id"></BaseSelect>
      </el-form-item>
      <el-form-item label="角色" prop="roles">
        <el-select
          style="width: 100%"
          v-model="model.roles"
          multiple
          placeholder="请选择职位"
        >
          <el-option
            v-for="item in roles"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { userNew, userUpdate, roleList } from '@/service/getData'

import BaseSelect from '@/components/select/base_select'

export default {
  components: {
    BaseSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      roles: [],
      rules: {
        name: [{ required: true, message: '请填写角色名', trigger: 'blur' }],
        phone_number: [
          {
            required: true,
            pattern: /^1\d{10}$/,
            message: '手机号错误',
            trigger: 'blur',
          },
        ],
        // base_id: [{ required: true, message: '请选择基地', trigger: 'change' }],
        roles: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个角色',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    this.getRoles()
  },
  methods: {
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.roles = res.data.list.filter((item) => item.status == 1)
      }
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await userUpdate(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await userNew(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>